export default __webpack_public_path__ + "static/media/capacitorjs.8fb886a5.svg";